import {useEffect, useState} from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion.tsx";
import {FAQ} from "@/types/FAQ.ts";
import {getFAQs} from "@/services/faqService.ts";
import {useTranslation} from "react-i18next";
import {getLocalizedFieldName} from "@/utils/translation-helper.ts";

export const LandingPageFAQ = () => {
  const {t} = useTranslation();
  const [FAQs, setFAQs] = useState<FAQ[]>([]);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const data = await getFAQs();
        setFAQs(data);
      } catch (error) {
        console.error(`Error fetching FAQ:`, error);
      }
    };

    fetchFAQs();
  }, []);

  return (
    <section
      id="faq"
      className="container py-24 sm:py-32"
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        {t("common.faq")}
      </h2>

      <Accordion
        type="single"
        collapsible
        className="w-full AccordionRoot"
      >
        {FAQs.map(faq => (
          <AccordionItem
            key={faq.id}
            value={faq.id?.toString() ?? ""}
          >
            <AccordionTrigger className="text-left">
              {faq[getLocalizedFieldName("question") as keyof FAQ]}
            </AccordionTrigger>

            <AccordionContent>{faq[getLocalizedFieldName("answer") as keyof FAQ]}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <h3 className="font-medium mt-4">
        {t("landing.stillHaveQuestions")}{" "}
        <a
          href="https://divertmentalhealth.ca/contact/"
          className="text-primary transition-all border-primary hover:border-b-2"
        >
          {t("common.contactUs")}
        </a>
      </h3>
    </section>
  );
};
